/*
 |--------------------------------------------------------------------------
 | Helpers
 |--------------------------------------------------------------------------
 */

import _ from "lodash";

const { DateTime, Settings } = require("luxon");
Settings.defaultLocale = window.Laravel.app.locale;
window.DateTime = DateTime;

/*
 |--------------------------------------------------------------------------
 | String Helpers
 |--------------------------------------------------------------------------
 */

/** Capitalize */
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/** Phone Format */
String.prototype.phoneFormat = function () {
  return `(${this.slice(0, 3)}) ${this.slice(3, 6)}-${this.slice(6, 10)}`;
};

/** Truncate Strings */
String.prototype.trunc = String.prototype.trunc ||
  function (n) {
    return (this.length > n) ? this.substr(0, n - 1) + "..." : this;
  };

/*
 |--------------------------------------------------------------------------
 | Number Helpers
 |--------------------------------------------------------------------------
 */

/** Number Format */
Number.prototype.format = function (c, d, t) {
  let n = this;
  c = isNaN(c = Math.abs(c)) ? 2 : c;
  d = d == undefined ? "." : d;
  t = t == undefined ? "," : t;
  let s = n < 0 ? "-" : "";
  let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
  let j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

/** Percentage Format */
Number.prototype.percentageFormat = function (n = 0) {
  return (this * 100).format(n, ",", " ") + "%";
};

/** Price Format */
Number.prototype.priceFormat = function (iso = "CAD") {

  if (iso == "USD") {
    return this.format(2, ",", "\xa0") + "\xa0$USD";
  }

  return this.format(2, ",", "\xa0") + "\xa0$CAD";
};

/** Number size format */
Number.prototype.fileSizeFormat = function () {
  let i = Math.floor(Math.log(this) / Math.log(1024));
  return (this / Math.pow(1024, i)).toFixed(2) * 1 + " " + ["B", "kB", "MB", "GB", "TB"][i];
};

/*
 |--------------------------------------------------------------------------
 | Date Helpers
 |--------------------------------------------------------------------------
 */

/** String to date */
window.stringToDate = function (date) {
  let s = date;
  let a = s.split(/[^0-9]/);
  return new Date(a[0], a[1] - 1, a[2], 0, 0, 0);
};

/** Date to String */
Date.prototype.format = function () {
  let date = new Date(this.getTime());
  let month = "" + (date.getMonth() + 1),
    day = "" + date.getDate(),
    year = date.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

/*
 |--------------------------------------------------------------------------
 | Misc
 |--------------------------------------------------------------------------
 */

/** Deep copy */
window.deepCopy = function (o) {
  return JSON.parse(JSON.stringify(o));
};

/** UUID Generator */
function uuid(n = 12) {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < n; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

window.uuid = uuid;

/** Currency converter */
function convertCurrency(amount, fromIso, toIso, rate = 1) {

  if (fromIso === toIso) {
    return amount;
  }

  if (fromIso == "CAD" && toIso == "USD") {
    return parseFloat((amount / rate).toFixed(2));
  }

  if (fromIso == "USD" && toIso == "CAD") {
    return parseFloat((amount * rate).toFixed(2));
  }

  return amount;
}

/*
 |--------------------------------------------------------------------------
 | Misc
 |--------------------------------------------------------------------------
 */

window.getColorNameById = function (id) {
  let color = Laravel.colors[id];
  if (color === this.undefined) {
    return null;
  }

  return _.get(color, "label." + Laravel.app.locale, color.code);
};

window.getFinitionNameById = function (id) {
  let finition = Laravel.finitions[id];
  if (finition === this.undefined) {
    return null;
  }

  return _.get(finition, "name." + Laravel.app.locale, finition.shortcut);
};

/**
 * Get base parameter without delimiter suffix
 * @param {String} parameter
 * @returns {String|null}
 */
window.getBaseParameter = function (parameter) {
  if (!parameter) {
    return null;
  }
  return parameter.split(window.Laravel.erp.rule_id_delimiter)[0];
};

/**
 * Check if parameter is color
 *
 * @param {String} parameter
 * @returns {Boolean}
 */
window.isColorParameter = function (parameter) {
  const baseParameter = window.getBaseParameter(parameter);

  if (!baseParameter) {
    return false;
  }

  return window.Laravel.erp.parameter_groups.couleur.includes(baseParameter);
};

window.parameterType = function (parameter) {
  if (window.isNumericParameter(parameter)) {
    return "numeric";
  }

  if (window.isFinitionParameter(parameter)) {
    return "finition";
  }

  if (window.isColorParameter(parameter)) {
    return "color";
  }

  return "option";
};

/**
 * Check if parameter is finition
 *
 * @param {String} parameter
 * @returns {Boolean}
 */
window.isFinitionParameter = function (parameter) {
  const baseParameter = window.getBaseParameter(parameter);

  if (!baseParameter) {
    return false;
  }

  return window.Laravel.erp.parameter_groups.fini.includes(baseParameter);
};

/**
 * Check if parameter is numeric
 *
 * @param {String} parameter
 * @returns {Boolean}
 */
window.isNumericParameter = function (parameter) {
  const baseParameter = window.getBaseParameter(parameter);

  if (!baseParameter) {
    return false;
  }

  return window.Laravel.erp.parameter_groups.numeric.includes(baseParameter);
};

/**
 * Check if parameter is option
 *
 * @param {String} parameter
 * @returns {Boolean}
 */
window.isOptionParameter = function (parameter) {
  return window.parameterType(parameter) == "option";
};

/*
 |--------------------------------------------------------------------------
 | Production hours helpers
 |--------------------------------------------------------------------------
 */

/**
 * Get departments that have production hours
 *
 * @returns {Array}
 */
window.haveProductionMinutesDepartments = function () {
  return _.cloneDeep(Laravel.erp.departments).filter((department) => {
    return department !== "machining";
  });
};


export { uuid, convertCurrency };
